import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { message } from "antd";
import PageContainer from "../../components/PageContainer";
import ChatHolder from "./message/ChatHolder";
import Footer from "./footer/Footer";
import Popup from "./footer/Popup";
import { getMessagesService } from "./chat.api";
import { getSessionDetailService } from "../archive/archive.api";
import {
  MessageServerConstant,
  MessageStatus,
  MessageType,
  SessionStatus,
} from "../../constant/Types";
import { addBulkMessage } from "../../actions/message";
import Battery from "./Battery";
import BottomSheet from "../../components/BottomSheet";
import RateToConversion from "./RateToConversion";
import SubscriberInfo from "./SubscriberInfo";
import { checkValue, convertUnixToPersianDate } from "../../constant/helper";
import { ChatLoadingContext } from "./ChatLoadingContextProvider";
import ChatHeaderLogo from "./ChatHeaderLogo/ChatHeaderLogo";

const messagePerPage = 1500;
export const InReplyContext = createContext();

const Chat = () => {
  const { sessionId, status, rootType } = useParams();
  const history = useHistory();
  const chatElement = useRef(null);
  const [showExteraInfo, setshowExteraInfo] = useState(false);
  const [inReply, setInReply] = useState();

  const dispatch = useDispatch();
  const { messages: messagesList, profile } = useSelector((state) => state);
  const { AllChatLoading, setAllChatLoading } = useContext(ChatLoadingContext);

  const [pageNumber, setPageNumber] = useState(1);
  const [lawyerInfo, setLawyerInfo] = useState(false);
  const [lawyerRateForm, setLawyerRateForm] = useState(false);
  const [batteryLoading, setBatteryLoading] = useState(false);
  const [scrollBtnView] = useState(false);
  const [totalElements, setTotalElements] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sessionDetail, setSessionDetail] = useState({
    sessionStatus: SessionStatus.STARTED,
  });

  // battery
  const [isOpen, setIsOpen] = useState(false);
  const [batteryInfo, setBatteryInfo] = useState(false);

  useEffect(() => {
    return () => {
      if (history.action === "POP") {
        history.replace("/home"); // replace back history with /home patch
      }
    };
  }, [history]);

  useEffect(() => {
    // CleanUp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (pageNumber === 1) {
      setTimeout(() => {
        scrollToBottom();
      }, 1000);
    }
    getMessages(pageNumber === 1, true);
    // eslint-disable-next-line
  }, [pageNumber]);

  useEffect(() => {
    if (chatElement && chatElement.current) {
      chatElement.current.addEventListener("scroll", handleScroll);
    }

    return function cleanup() {
      if (chatElement && chatElement.current) {
        // eslint-disable-next-line
        chatElement.current.removeEventListener("scroll", handleScroll);
      }
    };
    // eslint-disable-next-line
  }, [pageNumber, totalElements]);

  useEffect(
    () => {
      window.intervalTimerId = setInterval(function () {
        checkForNewMessages();
      }, 3000);
      return () => {
        if (window.intervalTimerId) {
          clearInterval(window.intervalTimerId);
        }
      };
    },
    //eslint-disable-next-line
    [getMessages]
  );

  function checkForNewMessages() {
    getMessagesService(sessionId, {
      pageNumber: 1,
      pageSize: (pageNumber + 1) * messagePerPage,
    })
      .then((resp) => {
        addMessages(resp.data.content, false);
      })
      .catch((error) => {
        message.error("خطا در دریافت اطلاعات");
        // history.push("/home");
      })
      .finally(() => {
        getSessionDetail();
      });
  }

  // eslint-disable-next-line
  function getMessages(
    firstFetch = false,
    isTriggeredByScroll = false,
    hasLoading = true
  ) {
    hasLoading && setLoading(true);
    getMessagesService(sessionId, {
      pageNumber: pageNumber,
      pageSize: messagePerPage,
    })
      .then((resp) => {
        addMessages(resp.data.content, firstFetch);
        if (firstFetch && resp.data.totalElements) {
          setTotalElements(resp.data.totalElements);
        }
      })
      .catch((error) => {
        message.error("خطا در دریافت اطلاعات");
        // history.push("/home");
      })
      .finally(() => {
        getSessionDetail();
        setLoading(false);
        if (firstFetch) {
          setTimeout(() => {
            scrollToBottom();
          }, 200);
        } else {
          isTriggeredByScroll && scrollAlittleBitToBottom();
        }
      });
  }

  function checkForNewMessagesFooter() {
    getMessagesService(sessionId, {
      pageNumber: 1,
      pageSize: (pageNumber + 1) * messagePerPage,
    })
      .then((resp) => {
        addMessages(resp.data.content, true);
      })
      .catch((error) => {
        message.error("خطا در دریافت اطلاعات");
        // history.push("/home");
      })
      .finally(() => {
        setAllChatLoading(false);
        getSessionDetail();
      });
  }
  const addMessages = useCallback(
    (messages, firstFetch) => {
      let result = [];
      messages.forEach((item) => {
        let msg = parsMessages(item);
        result.push(msg);
      });

      // result
      result.sort((a, b) => {
        const { time: timeA } = a;
        const { time: timeB } = b;

        return timeA - timeB;
      });

      dispatch(addBulkMessage(result, firstFetch));
      // }
    },
    //eslint-disable-next-line
    [dispatch, messagesList, parsMessages]
  );
  // eslint-disable-next-line
  function parsMessages(item) {
    const {
      messageType,
      userId,
      text,
      created,
      id,
      clientMessageId,
      fileUrl,
      filename,
      inReplyToTheMessage,
      call
    } = item;
    const filenameSplited = filename ? filename.split(".") : [];
    let result = {
      type: MessageType.client.text,
      data: {
        files: [],
        link: fileUrl,
        call,
        filename:
          convertUnixToPersianDate(created, "jYYYY/jMM/jDD_HH:mm") +
          "." +
          filenameSplited[filenameSplited.length - 1],
        text: text,
        highlighted: [],
        inReplyToTheMessage,
      },
      time: created,
      status: MessageStatus.ready,
      id,
      clientMessageId,
      otherProfile: item?.subscriber?.extraInfo?.avatarImageUrl || "",
    };

    // check user type: user, bot, lawyer, other
    if (
      userId === null ||
      (profile &&
        !profile.hasError &&
        !profile.loading &&
        userId &&
        profile.data.id &&
        profile.data.id.toString() === userId.toString())
    ) {
      // client
      if (messageType === MessageServerConstant.text) {
        result.type = MessageType.client.text;
      } else if (messageType === MessageServerConstant.images) {
        result.type = MessageType.client.image;
      } else if (
        messageType === MessageServerConstant.document ||
        messageType === MessageServerConstant.commented_document
      ) {
        result.type = MessageType.client.media;
      } else if (messageType === MessageServerConstant.voice) {
        result.type = MessageType.client.voice;
        result.status = MessageStatus.downloadable;
      } else if (messageType === MessageServerConstant.call) {
        result.type = MessageType.client.call;
      }
    } else if (userId === "bot") {
      // bot or support
      if (messageType === MessageServerConstant.text) {
        result.type = MessageType.support.text;
      } else if (messageType === MessageServerConstant.text_rate) {
        result.type = MessageType.support.rate;
      } else if (messageType === MessageServerConstant.call) {
        result.type = MessageType.support.call;
      }
    } else {
      // lawyer
      if (messageType === MessageServerConstant.text) {
        result.type = MessageType.lawyer.text;
      } else if (messageType === MessageServerConstant.images) {
        result.type = MessageType.lawyer.image;
      } else if (
        messageType === MessageServerConstant.document ||
        messageType === MessageServerConstant.commented_document
      ) {
        result.type = MessageType.lawyer.media;
      } else if (messageType === MessageServerConstant.voice) {
        result.type = MessageType.lawyer.voice;
        result.status = MessageStatus.downloadable;
      } else if (messageType === MessageServerConstant.call) {
        result.type = MessageType.lawyer.call;
      }
    }

    return result;
  }

  function getSessionDetail() {
    setBatteryLoading(true);
    getSessionDetailService(sessionId)
      .then((resp) => {
        setSessionDetail(resp.data);
        setBatteryInfo(
          resp.data.hasOwnProperty("battery") && resp.data.battery
        );

        setBatteryLoading(false);
      })
      .catch((error) => {
        message.error("خطایی در دریافت اطلاعات");
        setBatteryLoading(false);
      });
  }

  function toggleLawyerRateForm() {
    setLawyerRateForm(!lawyerRateForm);
  }

  function toggleLawyerInfo() {
    setLawyerInfo(!lawyerInfo);
  }

  const scrollToBottom = () => {
    if (chatElement && chatElement.current) {
      chatElement.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const scrollAlittleBitToBottom = () => {
    if (chatElement && chatElement.current) {
      chatElement.current.scrollTop = 5;
    }
  };

  const handleScroll = (e) => {
    let scrollTop = e.target.scrollTop;
    const lastPage = Math.ceil(totalElements / 10);
    if (scrollTop < 1 && pageNumber < lastPage) {
      setPageNumber((pageNumber) => pageNumber + 1);
    }
  };

  const fetchLawyerInfo = useCallback(() => {
    let result = {
      avatarImage: 3,
      name: "",
      description: "",
      workResume: "",
      education: "",
      categoryName: "",
      licenceNumber: "", // شماره پروانه
      licenceIssuedAt: "", //  تاریخ صدور پروانه
    };

    if (checkValue(sessionDetail.lawyer)) {
      if (checkValue(sessionDetail.lawyer?.extraInfo)) {
        if (checkValue(sessionDetail.lawyer?.extraInfo.firstName)) {
          result["name"] =
            sessionDetail.lawyer?.extraInfo.firstName ||
            "" + sessionDetail.lawyer?.extraInfo.lastName ||
            "";
        } else {
          result["name"] = sessionDetail.lawyer.username;
        }

        if (checkValue(sessionDetail.lawyer?.extraInfo?.avatarImageUrl)) {
          result["avatarImage"] =
            sessionDetail.lawyer?.extraInfo?.avatarImageUrl || "LAWONE";
        }

        if (checkValue(sessionDetail.categoryName)) {
          result["categoryName"] = sessionDetail.categoryName;
        }

        if (checkValue(sessionDetail.professionalProfile.licenceNumber)) {
          result["licenceNumber"] =
            sessionDetail.professionalProfile.licenceNumber;
        }

        if (checkValue(sessionDetail.professionalProfile.licenceIssuedAt)) {
          result["licenceIssuedAt"] =
            sessionDetail.professionalProfile.licenceIssuedAt;
        }
      }
    }

    return result;
  }, [sessionDetail]);

  const refresh = () => {
    getSessionDetail();
    getMessages();
  };

  function closeTopSheet() {
    setIsOpen(false);
  }

  return (
    <>
      <PageContainer
        classNames={"chat-page no-padding disable-select"}
        headerProps={{
          link: "/home",
          // isOpen:isOpen,
          content: (
            <Battery
              loading={batteryLoading}
              fetchInfo={getSessionDetail}
              info={batteryInfo}
              showLawyerInfo={!!sessionDetail.lawyer}
              lawyerInfo={sessionDetail.lawyer}
              toggleLawyerInfo={toggleLawyerInfo}
              isOpen={isOpen}
              setIsOpen={setIsOpen}
              sessionDetail={sessionDetail}
              openExteraInfo={() => setshowExteraInfo((prev) => !prev)}
              avatar={sessionDetail?.lawyer?.extraInfo?.avatarImageUrl}
            />
          ),
          className: "pos-fix header-battery chat-header",
        }}
        loading={loading || AllChatLoading}
      >
        {sessionDetail && (
          <ChatHeaderLogo
            show={showExteraInfo}
            close={() => setshowExteraInfo(false)}
            info={sessionDetail}
          />
        )}
        <InReplyContext.Provider value={{ inReply, setInReply }}>
          <ChatHolder
            rootType={rootType}
            messagesList={messagesList}
            hasMore={false}
            chatElement={chatElement}
            scrollToBottom={scrollToBottom}
            scrollBtnView={scrollBtnView}
            totalElements={totalElements}
            sessionId={sessionId}
            sessionDetail={sessionDetail}
            openLawyerRate={toggleLawyerRateForm}
            setLoading={setLoading}
          />
          <Footer
            messagesList={messagesList}
            showPopup={true}
            openLawyerRate={toggleLawyerRateForm}
            isBaseOnTime={status === "baseOnTime"}
            getMessages={checkForNewMessagesFooter}
            sessionId={sessionId}
            scrollToBottom={scrollToBottom}
            rootType={rootType}
            sessionDetail={sessionDetail}
            popup={
              <Popup
                refresh={refresh}
                sessionId={sessionId}
                rootType={rootType}
                batteryInfo={batteryInfo}
                sessionDetail={sessionDetail}
                isChatDisabled={
                  sessionDetail.sessionStatus === SessionStatus.CLOSED ||
                  sessionDetail.sessionStatus ===
                    SessionStatus.RECHARGE_NEEDED ||
                  sessionDetail.sessionStatus === SessionStatus.CLOSED_BY_ADMIN
                }
                otherType={
                  batteryInfo.timeBased &&
                  sessionDetail.sessionStatus ===
                    "SessionStatus.RECHARGE_NEEDED"
                    ? true
                    : sessionDetail.hasOwnProperty("battery") &&
                      sessionDetail.battery.hasOwnProperty("otherType") &&
                      sessionDetail.battery.otherType &&
                      sessionDetail.sessionStatus === "WAITING_FOR_CATEGORY"
                    ? sessionDetail.battery.otherType
                    : false
                }
              />
            }
            closeTopSheet={closeTopSheet}
          />
        </InReplyContext.Provider>
      </PageContainer>
      <BottomSheet
        setClose={toggleLawyerInfo}
        isOpen={lawyerInfo}
        classNames={"subscriber-info-holder"}
      >
        <SubscriberInfo
          closeBottomSheet={toggleLawyerRateForm}
          userInfo={fetchLawyerInfo()}
        />
      </BottomSheet>
      <BottomSheet
        setClose={toggleLawyerRateForm}
        isOpen={lawyerRateForm}
        classNames={"lawyer-rate-holder"}
      >
        <RateToConversion
          closeBottomSheet={toggleLawyerRateForm}
          userInfo={fetchLawyerInfo()}
          getSessionDetail={getSessionDetail}
        />
      </BottomSheet>
    </>
  );
};

export default Chat;
